enum BenchmarkingDashboardDetailsTypeEnum {
  None = 0,
  NetworkDrillin = 1,
  VennDiagramPrimaryOnly = 2,
  VennDiagramCommon = 3,
  VennDiagramComparisonOnly = 4,
  OverlapInNetwork = 5,
  OverlapOutNetwork = 6,
}

export { BenchmarkingDashboardDetailsTypeEnum };